<template>
  <v-expand-x-transition class='w-expandable-x'>
    <div
      v-show='value'
      class='w-expandable-x__content-wrapper'
    >
      <slot />
    </div>
  </v-expand-x-transition>
</template>

<script>
import { useTimerManager } from '@/composables/timer-manager';

/**
 * @component WorkExpandableX
 * @description Horizontal expand component with transition and optional
 * transition events. Equivalent to the variant in `expandable/` but
 * without a toggle button — control is exclusively via `value`.
 *
 * @prop {Boolean} value - Visibility (v-model). (Required)
 * @prop {Boolean} [withoutTransitionEvents=false] - Disable transition events.
 *
 * @emits {void} transition:started - When the animation starts.
 * @emits {void} transition:finished - After the animation completes.
 *
 * @slot default - Expandable content.
 */
export default {
  name: 'WorkExpandableX',
  props: {
    value: { type: Boolean, required: true },
    withoutTransitionEvents: { type: Boolean, default: false },
  },
  setup() {
    const { registerTimeout } = useTimerManager();
    return {
      registerTimeout,
    };
  },
  watch: {
    value() {
      if (this.withoutTransitionEvents === true) { return }

      this.$emit('transisiton:started');
      this.registerTimeout(() => this.$emit('transisiton:finished'), 300);
    }
  }
};
</script>
